import { useMutation } from '@tanstack/react-query';
import { axiosClient } from '../axiosClient';

interface AreaDatesQueryType {
  fieldName: string;
  categoryId: string;
}

interface AreaInformationFieldType {
  id: number;
  colour_max_value: number;
  colour_min_value: number;
  colour_unit: number;
  max_colour: string;
  min_colour: string;
}

interface AreaFieldResponseType {
  area_information_fields: AreaInformationFieldType[];
}

interface AreaDatesResponseType {
  area_information_dates: { valid_from: string }[];
}

interface DateOptionType {
  label: string;
  value: string;
}

const fetchAreaInformationField = async (
  fieldName: string
): Promise<AreaInformationFieldType | null> => {
  const URL = `${import.meta.env.VITE_API_AREA_FIELD_URL}?names=${encodeURIComponent(fieldName)}`;
  const { data } = await axiosClient.get<AreaFieldResponseType>(URL);

  return data?.area_information_fields?.[0] ?? null;
};

const useAreaDates = () => {
  return useMutation({
    mutationFn: async (
      query: AreaDatesQueryType
    ): Promise<DateOptionType[]> => {
      const field = await fetchAreaInformationField(query.fieldName);
      if (!field) return [];

      const URL = `${import.meta.env.VITE_API_AREA_DATES_URL}?field_ids=${field.id}&category_ids=${query.categoryId}`;
      const { data } = await axiosClient.get<AreaDatesResponseType>(URL);

      return (data?.area_information_dates ?? [])
        .map((item) => ({
          label: item.valid_from.substring(0, 7),
          value: item.valid_from,
        }))
        .sort((a, b) => b.value.localeCompare(a.value));
    },
  });
};

export default useAreaDates;
export { fetchAreaInformationField };
export type { AreaInformationFieldType, DateOptionType };
